module.exports = __webpack_public_path__ + "img/add-icon.23762185.png";